import React from 'react';

const MinimizeIcon = ({ className = "w-4 h-4", ...props }) => {
  return (
    <svg 
      xmlns="http://www.w3.org/2000/svg" 
      width="24" 
      height="24" 
      viewBox="0 0 24 24" 
      fill="none"
      className={className}
      {...props}
    >
      <path 
        d="M2 22L9 15M9 15H3.143M9 15V20.857M22 2L15 9M15 9H20.857M15 9V3.143" 
        stroke="currentColor" 
        strokeWidth="1.5" 
        strokeLinecap="round" 
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default MinimizeIcon;
